"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var utils_exports = {};
__export(utils_exports, {
  collectEventMetadata: () => collectEventMetadata,
  signupStore: () => signupStore,
  trackOAuthCompletion: () => trackOAuthCompletion,
  triggerUrlChange: () => triggerUrlChange
});
module.exports = __toCommonJS(utils_exports);
var import_ua_parser_js = require("ua-parser-js");
var import_platform = require("@hcengineering/platform");
var import_presentation = __toESM(require("@hcengineering/presentation"));
var import_ui = require("@hcengineering/ui");
var import_core = require("@hcengineering/core");
var import_analytics = require("@hcengineering/analytics");
let _isSignUp = false;
const signupStore = {
  setSignUpFlow: /* @__PURE__ */ __name((isSignUp) => {
    _isSignUp = isSignUp;
  }, "setSignUpFlow"),
  getSignUpFlow: /* @__PURE__ */ __name(() => {
    return _isSignUp;
  }, "getSignUpFlow")
};
class SessionManager {
  static {
    __name(this, "SessionManager");
  }
  static instance;
  sessionId;
  windowId;
  sessionStartTime;
  pageviewId;
  pageStartTime;
  eventCount = 0;
  pageViewCount = 0;
  currentUrl = "";
  constructor() {
    this.sessionId = (0, import_core.generateId)();
    this.windowId = (0, import_core.generateId)();
    this.sessionStartTime = Date.now();
    this.pageviewId = (0, import_core.generateId)();
    this.pageStartTime = Date.now();
    this.currentUrl = window.location.href;
    this.pageViewCount = 1;
    this.setupNavigationTracking();
  }
  static getInstance() {
    if (SessionManager.instance === void 0) {
      SessionManager.instance = new SessionManager();
    }
    return SessionManager.instance;
  }
  setupNavigationTracking() {
    window.addEventListener("popstate", () => {
      setTimeout(() => {
        this.onUrlChange();
      }, 0);
    });
    setInterval(() => {
      if (window.location.href !== this.currentUrl) {
        this.onUrlChange();
      }
    }, 5e3);
  }
  onUrlChange() {
    if (window.location.href !== this.currentUrl) {
      this.currentUrl = window.location.href;
      this.pageviewId = (0, import_core.generateId)();
      this.pageStartTime = Date.now();
      this.pageViewCount++;
    }
  }
  getSessionData() {
    const now = Date.now();
    const timeOnPage = Math.floor((now - this.pageStartTime) / 1e3);
    const sessionDuration = Math.floor((now - this.sessionStartTime) / 1e3);
    return {
      $session_id: this.sessionId,
      $window_id: this.windowId,
      $pageview_id: this.pageviewId,
      $session_duration: sessionDuration,
      $time_on_page: timeOnPage,
      $page_view_count: this.pageViewCount,
      $event_count: this.eventCount,
      $is_first_session: this.isFirstSession(),
      $is_returning_user: this.isReturningUser(),
      $insert_id: this.generateInsertId()
    };
  }
  incrementEventCount() {
    this.eventCount++;
  }
  generateInsertId() {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substr(2, 9);
    return `${timestamp}-${random}`;
  }
  isFirstSession() {
    const hasVisited = localStorage.getItem("analytics_has_visited");
    if (hasVisited === null || hasVisited === "") {
      localStorage.setItem("analytics_has_visited", "true");
      return true;
    }
    return false;
  }
  isReturningUser() {
    const firstVisit = localStorage.getItem("analytics_first_visit");
    const now = Date.now();
    if (firstVisit === null || firstVisit === "") {
      localStorage.setItem("analytics_first_visit", now.toString());
      return false;
    }
    const firstVisitTime = parseInt(firstVisit, 10);
    return now - firstVisitTime > 24 * 60 * 60 * 1e3;
  }
}
function triggerUrlChange() {
  SessionManager.getInstance().onUrlChange();
}
__name(triggerUrlChange, "triggerUrlChange");
function getUrlTrackingParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_term: params.get("utm_term"),
    utm_content: params.get("utm_content"),
    gclid: params.get("gclid"),
    gad_source: params.get("gad_source"),
    gclsrc: params.get("gclsrc"),
    dclid: params.get("dclid"),
    wbraid: params.get("wbraid"),
    gbraid: params.get("gbraid"),
    fbclid: params.get("fbclid"),
    msclkid: params.get("msclkid"),
    twclid: params.get("twclid"),
    li_fat_id: params.get("li_fat_id"),
    mc_cid: params.get("mc_cid"),
    igshid: params.get("igshid"),
    ttclid: params.get("ttclid")
  };
}
__name(getUrlTrackingParams, "getUrlTrackingParams");
function getSearchEngine(referrer) {
  if (referrer == null || referrer === "") return null;
  const domains = {
    "google.": "google",
    "bing.": "bing",
    "yahoo.": "yahoo",
    "duckduckgo.": "duckduckgo",
    "yandex.": "yandex"
  };
  for (const [domain, engine] of Object.entries(domains)) {
    if (referrer.includes(domain)) return engine;
  }
  return null;
}
__name(getSearchEngine, "getSearchEngine");
function getDeviceType(type) {
  if (type == null || type === "") return "Desktop";
  if (type === "mobile") return "Mobile";
  if (type === "tablet") return "Tablet";
  return "Desktop";
}
__name(getDeviceType, "getDeviceType");
function collectEventMetadata(properties = {}) {
  const parser = new import_ua_parser_js.UAParser();
  const browser = parser.getBrowser();
  const os = parser.getOS();
  const device = parser.getDevice();
  const sessionManager = SessionManager.getInstance();
  sessionManager.incrementEventCount();
  const sessionData = sessionManager.getSessionData();
  const urlTracking = getUrlTrackingParams();
  const searchEngine = getSearchEngine(document.referrer);
  const referrer = (() => {
    if (document.referrer === "") return "$direct";
    try {
      const currentDomain = window.location.hostname;
      const referrerDomain = new URL(document.referrer).hostname;
      if (currentDomain === referrerDomain) return "$direct";
      return document.referrer;
    } catch {
      return document.referrer;
    }
  })();
  const referringDomain = referrer !== "$direct" ? new URL(referrer).hostname : "$direct";
  const now = /* @__PURE__ */ new Date();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneOffset = -now.getTimezoneOffset();
  const browserLanguage = navigator.language !== "" ? navigator.language : "en-US";
  const browserLanguagePrefix = browserLanguage.split("-")[0] !== "" ? browserLanguage.split("-")[0] : "en";
  return {
    title: document.title,
    // User agent and platform info
    $lib: import_ui.desktopPlatform ? "app" : "web",
    $lib_version: (0, import_platform.getMetadata)(import_presentation.default.metadata.FrontVersion) ?? "0.0.0",
    $browser: browser.name ?? "Unknown Browser",
    $browser_version: parseInt(browser.major ?? "0", 10),
    $browser_language: browserLanguage,
    $browser_language_prefix: browserLanguagePrefix,
    $os: os.name ?? "Unknown OS",
    $os_version: os.version,
    $device_type: getDeviceType(device.type),
    $device_model: device.model,
    $device_vendor: device.vendor,
    $screen_height: window.screen.height,
    $screen_width: window.screen.width,
    $viewport_height: window.innerHeight,
    $viewport_width: window.innerWidth,
    $language: navigator.language,
    $raw_user_agent: navigator.userAgent,
    $timezone: timezone,
    $timezone_offset: timezoneOffset,
    $timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    // URL and referrer info
    $current_url: window.location.href,
    $host: window.location.host,
    $pathname: window.location.pathname,
    $search: window.location.search,
    referrer,
    $referring_domain: referringDomain,
    $search_engine: searchEngine,
    // Session and activity fields (PostHog-compatible)
    ...sessionData,
    // URL tracking parameters (UTM, etc.)
    ...urlTracking,
    // Custom event parameters
    ...properties
  };
}
__name(collectEventMetadata, "collectEventMetadata");
function getProviderFromUrl() {
  const location = (0, import_ui.getCurrentLocation)();
  const referrer = document.referrer;
  if (referrer !== "") {
    try {
      const referrerUrl = new URL(referrer);
      const hostname = referrerUrl.hostname;
      if (hostname === "accounts.google.com") {
        return "google";
      } else if (hostname === "github.com") {
        return "github";
      }
    } catch (error) {
    }
  }
  if (location.query?.provider != null && location.query.provider !== "") {
    return location.query.provider;
  }
  return null;
}
__name(getProviderFromUrl, "getProviderFromUrl");
function trackOAuthCompletion(result) {
  const provider = getProviderFromUrl();
  if (provider == null) return;
  const isSignUp = signupStore.getSignUpFlow();
  const success = result != null;
  const eventPrefix = isSignUp ? "signup" : "login";
  const eventSuffix = success ? "completed" : "error";
  const eventName = `${eventPrefix}.${provider}.${eventSuffix}`;
  import_analytics.Analytics.handleEvent(eventName);
}
__name(trackOAuthCompletion, "trackOAuthCompletion");
//# sourceMappingURL=utils.js.map
